<script>
import options from './TeamList.options'
export default options
</script>

<template>
  <article class="kb-team-list">
    <div class="kb-team-list__meta-top-container">
      <div class="kb-team-list__meta-top-container-count" aria-live="polite">
        <span>{{ totalAmount }}</span> {{ getLabel('resultTypeTitle') }}
      </div>
      <SortDropdown
        v-if="sortOptions && filterShown"
        :config="sortOptions"
        guid="required-but-not-relevant"
        :sortingHandler="sortingHandler"
      />
    </div>

    <div class="kb-team-list__container">
      <ul class="kb-team-list__container-list">
        <template v-for="(team, index) in teams" :key="index">
          <template v-if="index < teamsShownAmount">
            <li>
              <TeamListCard
                :captainText="getLabel('captainText')"
                :participantsText="getLabel('participantsText')"
                :captains="team.captains"
                :imageUrl="team.imageUrl"
                :imageAlt="team.imageAlt"
                :url="team.url"
                :name="team.name"
                :membersCount="team.numberOfDeltagere"
                :currencyText="getLabel('currencyText')"
                :donationGoalsText="getLabel('donationGoalsText')"
                :donationGoals="team.donationGoals"
                :donationTotal="team.donationTotal"
              />
            </li>
          </template>
        </template>
      </ul>
      
      <template v-if="teamsShownAmount && !showSpinner">
        <div class="kb-team-list__container-show-more">
          <p class="kb-team-list__container-show-more-text">
            {{
              getLabel('resultCountTitle', [
                teamsShownAmount.toString(),
                totalAmount.toString()
              ])
            }}
          </p>
  
          <template v-if="teamsShownAmount < totalAmount">
            <button
              @click="getMoreResults"
              class="kb-button kb-button--full-color"
            >
              {{ getLabel('showMoreButtonText') }}
            </button>
          </template>
        </div>
      </template>

    </div>

    <template v-if="!teamsShownAmount && !showSpinner && !hideNoResults">
      <div class="kb-general-search__no-results">
        <h2>{{ getLabel('noResultTitle') }}</h2>
        <p class="kb-general-search__no-results__summary">
          {{ getLabel('noResultDesc') }}
        </p>
        <a
          :href="getLabel('noResultButtonHref')"
          class="kb-button kb-button--full-color-spot"
          >{{ getLabel('noResultButtonText') }}</a
        >
      </div>
    </template>

    <div v-if="showSpinner" class="kb-spinner-overlay">
      <div class="kb-spinner-overlay__spinner"></div>
    </div>
  </article>
</template>
